import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JsonConvert } from 'json2typescript';
import { HvlPage, HvlResponse } from '@hvlng/framework-bff/core';
import { Hr } from '../model/hr.configuration.model';
import { HrConfigurationService } from '../service/hr.configuration.service';


export class HrRestServiceBase {
    readonly endpoint: string;
    readonly serviceRoot: string;


    protected readonly httpClient = inject(HttpClient);
    protected readonly configService = inject(HrConfigurationService);
    protected readonly converter: JsonConvert = new JsonConvert();

    constructor(endpointModule: keyof Hr, serviceRootSuffix: string) {
        this.endpoint = this.configService.config.hr[endpointModule as string];
        this.serviceRoot = this.endpoint + serviceRootSuffix;
    }

    protected getPageFromResponse<T extends object>(response: HvlResponse<HvlPage<T[]>>, classReference: {new (): T;} | null): HvlPage<T[]>{
        if (response.body?.totalElements === 0) {
            return new HvlPage<Array<T>>(
                [],
                response.body.totalElements,
                response.body.totalPages,
                response.errorDetail,
            );
        }
        const model = this.converter.deserializeArray(response.body.data, classReference);
        return new HvlPage<Array<T>>(
            model,
            response.body.totalElements,
            response.body.totalPages,
            response.errorDetail,
        );
    }

}
